<div class="sc-message--text">{message.data.text}</div>

<style>
 .sc-message--text {
   padding: 17px 20px;
   border-radius: 6px;
   font-weight: 300;
   font-size: 14px;
   line-height: 1.4;
   white-space: pre-wrap;
   -webkit-font-smoothing: subpixel-antialiased
 }

</style>

<script>
 export default {
 }

</script>
